/* Tyrexin - shared UI behaviors. Vanilla, event-delegated where possible. */
(function () {
  "use strict";

  /* Sticky header: blur shadow after 60px */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 60); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Mobile menu */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-menu-toggle]");
    if (!t) return;
    var menu = document.querySelector("[data-mobile-menu]");
    if (!menu) return;
    var open = menu.classList.toggle("is-open");
    if (open) { menu.hidden = false; } else { menu.hidden = true; }
    t.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* Accordions: one open per container. Markup:
     [data-accordion] > [data-accordion-item] > button[data-accordion-trigger] + [data-accordion-panel] */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest("[data-accordion-trigger]");
    if (!trig) return;
    var item = trig.closest("[data-accordion-item]");
    var container = trig.closest("[data-accordion]");
    if (!item || !container) return;
    var isOpen = item.classList.contains("is-open");
    if (!container.hasAttribute("data-accordion-multi")) {
      container.querySelectorAll("[data-accordion-item].is-open").forEach(function (it) {
        it.classList.remove("is-open");
        var b = it.querySelector("[data-accordion-trigger]"); if (b) b.setAttribute("aria-expanded", "false");
      });
    }
    item.classList.toggle("is-open", !isOpen);
    trig.setAttribute("aria-expanded", !isOpen ? "true" : "false");
  });

  /* Tabs: [data-tabs] with [data-tab="key"] triggers and [data-tab-panel="key"] panels */
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-tab]");
    if (!tab) return;
    var wrap = tab.closest("[data-tabs]");
    if (!wrap) return;
    var key = tab.getAttribute("data-tab");
    wrap.querySelectorAll("[data-tab]").forEach(function (t) { t.classList.toggle("is-active", t === tab); t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
    wrap.querySelectorAll("[data-tab-panel]").forEach(function (p) { p.hidden = p.getAttribute("data-tab-panel") !== key; });
  });

  /* Generic quantity stepper: [data-qty] wrapper with [data-qty-minus]/[data-qty-plus] and input[name=quantity] */
  document.addEventListener("click", function (e) {
    var dec = e.target.closest("[data-qty-minus]");
    var inc = e.target.closest("[data-qty-plus]");
    if (!dec && !inc) return;
    var wrap = (dec || inc).closest("[data-qty]");
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = inc ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* FAQ search + category filter: [data-faq] with input[data-faq-search], [data-faq-cat], items [data-faq-item] (data-cat, data-text) */
  document.querySelectorAll("[data-faq]").forEach(function (faq) {
    var search = faq.querySelector("[data-faq-search]");
    var cats = faq.querySelectorAll("[data-faq-cat]");
    var items = faq.querySelectorAll("[data-faq-item]");
    var counter = faq.querySelector("[data-faq-count]");
    var activeCat = "all";
    function apply() {
      var q = (search && search.value || "").toLowerCase().trim();
      var shown = 0;
      items.forEach(function (it) {
        var matchCat = activeCat === "all" || it.getAttribute("data-cat") === activeCat;
        var matchQ = !q || (it.getAttribute("data-text") || "").toLowerCase().indexOf(q) !== -1;
        var ok = matchCat && matchQ;
        it.hidden = !ok;
        if (ok) shown++;
      });
      if (counter) counter.textContent = shown;
      var empty = faq.querySelector("[data-faq-empty]");
      if (empty) empty.hidden = shown !== 0;
    }
    if (search) search.addEventListener("input", apply);
    cats.forEach(function (c) {
      c.addEventListener("click", function () {
        activeCat = c.getAttribute("data-faq-cat");
        cats.forEach(function (x) { x.classList.toggle("is-active", x === c); });
        apply();
      });
    });
    apply();
  });

  /* Reveal-on-scroll */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    document.querySelectorAll("[data-reveal]").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* Sticky mobile CTA: show [data-sticky-cta] after scrolling past [data-sticky-after] (or 600px) */
  var sticky = document.querySelector("[data-sticky-cta]");
  if (sticky) {
    var after = parseInt(sticky.getAttribute("data-sticky-after"), 10) || 600;
    var stickyScroll = function () { sticky.classList.toggle("is-visible", window.scrollY > after); };
    stickyScroll();
    window.addEventListener("scroll", stickyScroll, { passive: true });
  }
})();
